import Compressor from 'compressorjs';
import { uploadImage } from 'src/local-logic/tip-match/upload';

export function compressImage(file) {
  return new Promise((resolve, reject) => {
    // qq环境压缩后上传会失败，先兼容下
    if (app.env.isQQ) {
      resolve(file);
      return;
    }
    new Compressor(file, {
      quality: 0.9,
      maxWidth: 1500,
      maxHeight: 1500,
      success(blob) {
        const compressedFile = new File([blob], blob.name, { type: blob.type });
        compressedFile.status = file.status;
        resolve(compressedFile);
      },
      error(err) {
        console.log(err);
        reject(err);
      },
    });
  });
}

export function getUploadImageHash(data, callback, needCrop = false) {
  uploadImage(data, callback, needCrop);
}

